import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SharedModule } from '../shared/shared.module';
import { WizardModule } from './wizard/wizard.module';
import { DesigningModule } from './designing/designing.module';
import { routes } from './stories.routes';
import { ImagePreprocessingService } from './new/image-preprocessing.service';
import { ImageFilteringService } from './new/image-filtering.service';

import { NewStoryComponent } from './new/new.component';
import { UploadWizardService } from './wizard/wizard.service';
import { DesigningService } from './designing/designing.service';
import { ShowStoryComponent } from './show/show.component';
import { ShowStoryService } from './show/show.service';
import { StoriesListComponent } from './list/list.component';
import { PhotosPopupComponent } from './photosPopup/photosPopup.component';
import { PrintStoryComponent } from './print/print.component';
import { PrintStep1Component } from './print/step1/step1.component';
import { PrintStep2Component } from './print/step2/step2.component';
import { PrintStep3Component } from './print/step3/step3.component';
import { PrintPaymentStepComponent } from './print/printPaymentStep/printPaymentStep.component';
import { PrintSummaryStepComponent } from './print/printSummaryStep/printSummaryStep.component';
import { PrintStep6Component } from './print/step6/step6.component';
import { EditShippingAddressComponent } from './print/step2/editAddress/editAddress.component';
import { SelectShippingAddressComponent } from './print/step2/selectAddress/selectAddress.component';
import { SelectCardComponent } from './print/printPaymentStep/selectCard/selectCard.component';
import { AddCardComponent } from './print/printPaymentStep/addCard/addCard.component';
import { OrdersComponent } from './orders/orders.component';
import { OrdersService } from '../services/orders.service';
import { AlbumComponent } from './show/album.component';
import { PreviewsComponent } from './show/previews.component';
import { OrderComponent } from './orders/order.component';
import { SortablejsModule } from 'angular-sortablejs';
import { CanDeactivatePrintFlow } from './print/can-deactivate-print-flow.service';
import { StoryLinkComponent } from './list/story-link/story-link.component';
import { ShowErrorComponent } from './show/show-error/show-error.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FacebookLoginComponent } from 'app/+account/facebook-login/facebook-login.component';
import { AccountModule } from 'app/+account/account.module';
import { ContribService } from 'app/+projects/contrib/contrib.service';
import { PhotoGridService } from 'app/services/photo-grid.service';
import { FileUploadModule } from 'ng2-file-upload';
import { AppModule } from 'app/app.module';
import { AddPhotosToGridService } from 'app/services/add-photos-to-grid.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    NewStoryComponent,
    ShowStoryComponent,
    StoriesListComponent,
    PhotosPopupComponent,
    PrintStoryComponent,
    PrintStep1Component,
    PrintStep2Component,
    PrintStep3Component,
    PrintPaymentStepComponent,
    PrintSummaryStepComponent,
    PrintStep6Component,
    EditShippingAddressComponent,
    SelectShippingAddressComponent,
    SelectCardComponent,
    AddCardComponent,
    OrdersComponent,
    AlbumComponent,
    PreviewsComponent,
    OrderComponent,
    StoryLinkComponent,
    ShowErrorComponent,
  ],
  imports: [
    FileUploadModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    TranslateModule,
    ClipboardModule,
    AngularSvgIconModule,
    SharedModule,
    WizardModule,
    DesigningModule,
    SortablejsModule,
    NgxFileDropModule,
    AccountModule,
  ],
  providers: [
    ShowStoryService,
    ImagePreprocessingService,
    ImageFilteringService,
    UploadWizardService,
    DesigningService,
    OrdersService,
    CanDeactivatePrintFlow,
    ContribService,
  ],
  exports: [
    PhotosPopupComponent,
    ShowStoryComponent,
  ],
})
export class StoriesModule {
  public static routes = routes;
}
